import { LicensePlan } from '../../types';

export const office365Plans: LicensePlan[] = [
  {
    id: 'o365-e1-no-teams',
    name: 'Office 365 E1 (no Teams)',
    description: 'Business essentials - web apps and business services',
    pricing: {
      points: [
        { amount: 6.79, currency: 'USD', unit: 'user/month', effective: '1970-01-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '50 GB mailbox' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: false, additionalInfo: 'Sold separately — see with-Teams suite pricing' },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: false },
      { name: 'OneDrive for Business', included: true, additionalInfo: '1 TB storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: false },
      { name: 'URL time-of-click protection', included: true, additionalInfo: 'Summer 2026 packaging' },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  },
  {
    id: 'o365-e1-with-teams',
    name: 'Office 365 E1 with Teams',
    description: 'Business essentials with Teams collaboration',
    pricing: {
      points: [
        { amount: 10.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '50 GB mailbox' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: false },
      { name: 'OneDrive for Business', included: true, additionalInfo: '1 TB storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: false },
      { name: 'URL time-of-click protection', included: true, additionalInfo: 'Summer 2026 packaging' },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  },
  {
    id: 'o365-e3-no-teams',
    name: 'Office 365 E3 (no Teams)',
    description: 'Desktop apps plus web apps and business services',
    pricing: {
      points: [
        { amount: 14.45, currency: 'USD', unit: 'user/month', effective: '1970-01-01' },
        { amount: 17.45, currency: 'USD', unit: 'user/month', effective: '2026-07-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '100 GB mailbox' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: false, additionalInfo: 'Sold separately — see with-Teams suite pricing' },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: false },
      { name: 'Rights Management', included: true },
      { name: 'Data Loss Prevention', included: true },
      { name: 'Microsoft Defender for Office 365', included: true, additionalInfo: 'Plan 1 — summer 2026 packaging' },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  },
  {
    id: 'o365-e3-with-teams',
    name: 'Office 365 E3 with Teams',
    description: 'Desktop apps, web apps, and Teams collaboration',
    pricing: {
      points: [
        { amount: 23.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01' },
        { amount: 26.0, currency: 'USD', unit: 'user/month', effective: '2026-07-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: '100 GB mailbox' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: false },
      { name: 'Rights Management', included: true },
      { name: 'Data Loss Prevention', included: true },
      { name: 'Microsoft Defender for Office 365', included: true, additionalInfo: 'Plan 1 — summer 2026 packaging' },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  },
  {
    id: 'o365-e5-no-teams',
    name: 'Office 365 E5 (no Teams)',
    description: 'Advanced security, analytics, and voice capabilities',
    pricing: {
      points: [
        { amount: 29.45, currency: 'USD', unit: 'user/month', effective: '1970-01-01' },
        { amount: 32.45, currency: 'USD', unit: 'user/month', effective: '2026-07-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'Unlimited archive' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: false, additionalInfo: 'Sold separately — see with-Teams suite pricing' },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: true },
      { name: 'Phone System', included: true, additionalInfo: 'Calling Plan sold separately' },
      { name: 'Advanced eDiscovery', included: true },
      { name: 'Microsoft Defender for Office 365', included: true },
      { name: 'Power BI Pro', included: true },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  },
  {
    id: 'o365-e5-with-teams',
    name: 'Office 365 E5 with Teams',
    description: 'Advanced security, analytics, voice capabilities, and Teams',
    pricing: {
      points: [
        { amount: 38.0, currency: 'USD', unit: 'user/month', effective: '1970-01-01' },
        { amount: 41.0, currency: 'USD', unit: 'user/month', effective: '2026-07-01' }
      ]
    },
    features: [
      { name: 'Exchange Online', included: true, additionalInfo: 'Unlimited archive' },
      { name: 'SharePoint Online', included: true, additionalInfo: '1 TB + 10 GB per license' },
      { name: 'Microsoft Teams', included: true },
      { name: 'Web versions of Office', included: true },
      { name: 'Desktop Office apps', included: true },
      { name: 'OneDrive for Business', included: true, additionalInfo: 'Unlimited storage' },
      { name: 'Viva Engage (Yammer)', included: true },
      { name: 'Stream', included: true },
      { name: 'Planner', included: true },
      { name: 'Audio Conferencing', included: true },
      { name: 'Phone System', included: true, additionalInfo: 'Calling Plan sold separately' },
      { name: 'Advanced eDiscovery', included: true },
      { name: 'Microsoft Defender for Office 365', included: true },
      { name: 'Power BI Pro', included: true },
      { name: 'Copilot Chat enhancements', included: true, additionalInfo: 'Inbox/calendar awareness + Word, Excel, PowerPoint agents' },
      { name: 'Copilot Chat Analytics', included: true },
    ]
  }
];
